export default __webpack_public_path__ + "maps-overview-header-image-1200-35516a7d2fd708b6c242948f7c565e40.webp";